import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { GetAttendanceStatisticPayload } from "../../payload/GetAttendanceStatistic/GetAttendanceStatisticPayload";

const getAttendanceStatisticFetch = (state: ServiceState, action: PayloadAction<GetAttendanceStatisticPayload>) => {
    state.isLoading = true;
}

export default getAttendanceStatisticFetch;